import script from "./EventIcons.vue?vue&type=script&lang=ts&setup=true"
export * from "./EventIcons.vue?vue&type=script&lang=ts&setup=true"

import "./EventIcons.vue?vue&type=style&index=0&id=88548166&scoped=true&lang=scss"

import exportComponent from "/github/workspace/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-88548166"]])

export default __exports__